/* eslint-disable no-console */
import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import Box from 'ui-box';
import { Typography } from 'antd';
import { ReactComponent as SignalSvg } from '../../../assets/icons/user-account/signal.svg';
import { ReactComponent as TelegramSvg } from '../../../assets/icons/user-account/telegram.svg';
import { ReactComponent as ViberSvg } from '../../../assets/icons/user-account/viber.svg';
import { ReactComponent as WhatsappSvg } from '../../../assets/icons/user-account/whatsapp.svg';
import { ReactComponent as PhoneSvg } from '../../../assets/icons/user-account/phone.svg';
import { ReactComponent as CheckSvg } from '../../../assets/icons/user-account/check.svg';

const { Title } = Typography;

const styles = {
  box: {
    display: "flex",
    flexDirection: "row",
    justify: "space-between",
    alignItems: "center",
    background: "#0193CB",
    borderRadius: "5px",
    marginBottom: 10,
    position: "relative"
  },
  title: {
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "24px",
    color: "#FFFFFF",
    textAlign: "center",
    marginBottom: 0,
    width: "calc(85% - 50px)"
  },
  circle: {
    position: "absolute",
    right: 12,
    top: 0,
    bottom: 0,
    margin: "auto"
  }
}

function BoxUserCallMethod({ fieldName, selectedMethod }) {
  const { setFieldValue } = useFormikContext();

  const showCheck = (value) => {
    return selectedMethod === value ? <CheckSvg style={styles.circle} /> : <></>
  }

  const setOpacity = (value) => {
    return selectedMethod === value ? "1" : "0.6";
  }

  return (
    <Box>
      <Box style={{...styles.box, ...{background: "#0193CB", opacity: setOpacity("direct")}}} onClick={() => setFieldValue(fieldName, "direct")}>
        <PhoneSvg />
        <Title level={4} style={styles.title}>
          Direct Call
        </Title>
        {showCheck("direct")}
      </Box>
      <Box style={{...styles.box, ...{background: "#6C23A5", opacity: setOpacity("viber") }}} onClick={() => setFieldValue(fieldName, "viber")}>
        <ViberSvg />
        <Title level={4} style={styles.title}>
          Viber Call
        </Title>
        {showCheck("viber")}
      </Box>
      <Box style={{...styles.box, ...{background: "#1552CE", opacity: setOpacity("signal") }}} onClick={() => setFieldValue(fieldName, "signal")}>
        <SignalSvg />
        <Title level={4} style={styles.title}>
          Signal Call
        </Title>
        {showCheck("signal")}
      </Box>
      <Box style={{...styles.box, ...{background: "#10AF21", opacity: setOpacity("whatsapp") }}} onClick={() => setFieldValue(fieldName, "whatsapp")}>
        <WhatsappSvg />
        <Title level={4} style={styles.title}>
          Whatsapp Call
        </Title>
        {showCheck("whatsapp")}
      </Box>
      <Box style={{...styles.box, ...{background: "#2899CB", opacity: setOpacity("telegram") }}} onClick={() => setFieldValue(fieldName, "telegram")}>
        <TelegramSvg />
        <Title level={4} style={styles.title}>
          Telegram Call
        </Title>
        {showCheck("telegram")}
      </Box>
    </Box>
  );
}

const { string } = PropTypes;

BoxUserCallMethod.propTypes = {
  fieldName: string,
  selectedMethod: string
};

export default BoxUserCallMethod;
